// Hidden Apple Pay / Google Pay trial: ?applepay=1 on the page URL. Read once at load,
// before any navigation drops the query. Remove once Dojo wallets are switched on for real.
export function readWalletTest(search) {
  try { return new URLSearchParams(search).get('applepay') === '1'; } catch { return false; }
}

export const WALLET_TEST = readWalletTest(typeof window === 'undefined' ? '' : window.location.search);
